import BaseForgeCustomizer from '../base-forge';
import ProxyFooter from '../../components/common/ProxyFooter';
import WebAuthnEnrollInfo from '../../components/enroll-webauthn/WebAuthnEnrollInfo';
import WebAuthnSetupButton from '../../components/enroll-webauthn/WebAuthnSetupButton';
import { isAnetUser } from '../../utils/user-utils';
import { getOktaWidgetModel } from '../../utils/widget-facade';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { MFA_ENROLL_EVENT_PREFIX } from '../../constants';

export default class EnrollWebAuthnCustomizer extends BaseForgeCustomizer {
  displayFooterText = isAnetUser();

  async shouldCustomize(): Promise<boolean> {
    return this.context?.controller === 'enroll-webauthn';
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent('WebAuthn::Landing');
    this.forgifyEnrollInfo();
    this.forgifySetupButton();
    this.onFidoEnrollmentError();
    this.onIdxProceed();
    super.forgifyController();
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    return (
      <div className="fe_u_margin--top-large">
        <ProxyFooter
          text={this.footerText}
          footerLinks={footerLink.not('[data-se=cancel]')}
          alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
        />
      </div>
    );
  }

  private forgifyEnrollInfo() {
    const oktaEnrollText = jQueryCourage('.idx-webauthn-enroll-text').parent()
      .hide();
    this.renderForgeAndHideOktaComponent({
      id: 'webauthn-enroll-info',
      oktaComponent: oktaEnrollText,
      forgeComponent: <WebAuthnEnrollInfo />,
    });
  }

  private forgifySetupButton() {
    const setUpButton = jQueryCourage('.webauthn-setup');
    this.renderForgeAndHideOktaComponent({
      id: 'webauthn-setup',
      oktaComponent: setUpButton,
      forgeComponent: <WebAuthnSetupButton oktaButton={setUpButton} />,
    });
  }

  private onFidoEnrollmentError() {
    const widgetModel = getOktaWidgetModel();
    widgetModel.on('error', (_: any, error: any) => {
      if (this.context?.controller === 'enroll-webauthn') {
        AmplitudeUtils.logCustomEvent(`${MFA_ENROLL_EVENT_PREFIX}WebAuthn::Error`, { error });
        this.eventEmitter.emitEventToComponent({
          componentName: WebAuthnSetupButton.displayName!,
          eventName: 'webauthn-setup-error',
          eventPayload: { hasError: true },
        });
      }
    });
  }

  private onIdxProceed() {
    const {
      oktaSignIn: { authClient },
    } = this;
    const originalProceed = authClient.idx.proceed.bind(authClient);
    authClient.idx.proceed = async (...args: any) => {
      const response = await originalProceed.apply(authClient, args);
      if (args[0].step === 'enroll-authenticator' && response.requestDidSucceed) {
        AmplitudeUtils.logMfaEnrollEvent('WebAuthn::Success');
      }
      return response;
    };
  }
}
